import React from "react";
import styled from 'styled-components'

const status = {
  status: String
}

const changeStatus = (status) => {
  switch (status) {
    case 'ERROR':
    case 'FAIL':
    case 'REJECT':
    case 'RED':
    case 'PAYMENT_FAIL':
    case 'PAYOUT_FAIL':
      return `
        background: linear-gradient(40deg, #FF0000 30%, #FB4B6B 90%);
      `;
    case 'PENDING':
    case 'CONSIDERATION':
    case 'YELLOW':
    case 'DEBUG':
    case 'PAYMENT_PENDING':
    case 'PAYOUT_PENDING':
      return `
        background: linear-gradient(40deg, #FF7A00 30%, #FFBB38 90%);
      `;
    case 'PROCESSED':
    case 'APPROVE':
    case 'GREEN':
    case 'PAYMENT_PROCESSED':
    case 'EXCHANGE_PROCESSED':
      return `
        background: linear-gradient(40deg, #277661 -20%, #29DEAE 70%);
      `;
    default:
      return `
        background: linear-gradient(40deg, #3f51b5 30%, #62a0fe 90%);
      `;
  }
}

export const StyledStatus = styled('div', status)`
  ${({minWidth}) => minWidth ? `min-width: ${minWidth}px` : `min-width: 90px`};
  padding: 2px 15px;
  color: #fff;
  font-size: 12px;
  font-weight: 600;
  text-align: center;
  text-transform: capitalize;
  border-radius: 30px;
  display: inline-grid;
  ${({status}) => changeStatus(status)};
`;

const RenderStatus = ({as, status, minWidth}) => {
  return (
    <StyledStatus as={as} status={status} minWidth={minWidth}>
      {status?.toLowerCase().replace(/_/g, " ")}
    </StyledStatus>
  )
}

export default RenderStatus;